/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Icon from '../../../../modules/react/components/stateless/Icon';
import AdminIcon from './Icon';
import Template from '../../stateless/Popup/Template';
import PopupBody from './PopupBody';
import ThankYouBody from './ThankYouBody';
import styles from './styles.scss';

const propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onLeadFormSubmitted: PropTypes.func.isRequired,
  inAdminBuilder: PropTypes.bool.isRequired,
  showThankYou: PropTypes.bool.isRequired,
  featuredImage: PropTypes.string,
  medium: PropTypes.object,
  popupHeaderText: PropTypes.string.isRequired,
  popupBodyContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  popupIncludeForm: PropTypes.bool.isRequired,
  popupButtonText: PropTypes.string.isRequired,
  thankYouHeaderText: PropTypes.string.isRequired,
  thankYouBodyContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  thankYouButtonText: PropTypes.string.isRequired,
  settingsLeadSource: PropTypes.string.isRequired,
};

const defaultProps = {
  featuredImage: undefined,
  medium: undefined,
};

const Popup = ({
  show,
  onClose,
  onLeadFormSubmitted,
  inAdminBuilder,
  showThankYou,
  featuredImage,
  medium,
  popupHeaderText,
  popupBodyContent,
  popupIncludeForm,
  popupButtonText,
  thankYouHeaderText,
  thankYouBodyContent,
  thankYouButtonText,
  settingsLeadSource,
}) => {
  if (inAdminBuilder) {
    return <AdminIcon />;
  }

  const popupProps = {
    popupHeaderText,
    popupBodyContent,
    popupIncludeForm,
    popupButtonText,
    onLeadFormSubmitted,
    settingsLeadSource,
  };

  const thankYouProps = {
    thankYouHeaderText,
    thankYouBodyContent,
    thankYouButtonText,
    onClose,
  };

  return (
    <Modal dialogClassName={styles.popup} show={show} onHide={onClose}>
      <span className={styles.exit} onClick={onClose}>
        <Icon id="exit" />
      </span>
      <Template featuredImage={featuredImage} medium={medium}>
        {showThankYou ? <ThankYouBody {...thankYouProps} /> : <PopupBody {...popupProps} />}
      </Template>
    </Modal>
  );
};

Popup.propTypes = propTypes;
Popup.defaultProps = defaultProps;

export default Popup;
